
define('text!templates/parts/modal/zoom-meeting-created-modal.html',[],function () { return '<p class="ellipsis-wrap">\n    {{#t}}conversation:click-on-the-following-link-modal{{/t}} <a href="{{start_url}}" target="_blank">{{start_url}}</a>\n</p>\n';});

